import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
import profileImage from "../assets/images/profile.jpg";
import "../styles/Hero.css";

const Hero = () => {
  const handleScrollDown = () => {
    document.getElementById("about").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-grid">
        {/* Left Column - Social Media Icons */}
        <div className="social-media">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f"></i>
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-twitter"></i>
          </a>
        </div>

        {/* Center Column - Text Content */}
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1>
            <span>Hi, I'am </span> Abhay Rijal
          </h1>
          <h2>Junior Developer</h2>
          <p>Enhancing Web Development experiences, providing enhanced web based experiences</p>
          <Link
          to="contact"
          duration={500}
          className="cta-button"
        >
          <i className="fas fa-envelope"></i> Contact Me
        </Link>
        </motion.div>

        {/* Right Column - Profile Image */}
        <div className="profile-image-container">
          <div className="profile-image">
            <img src={profileImage} alt="Abhay Rijal" />
          </div>
        </div>
      </div>
      {/* Scroll Down Button */}
      <motion.div
        className="scroll-down"
        transition={{ delay: 1, duration: 1 }}
        onClick={handleScrollDown}
      >
        <i className="bi bi-mouse"></i> Scroll down{" "}
        <i className="fas fa-chevron-down"></i>
      </motion.div>
    </section>
  );
};

export default Hero;
